module.exports = __webpack_public_path__ + "static/media/settings-gears.eadac01d.svg";